import { render, staticRenderFns } from "./DadosCadastroForm.vue?vue&type=template&id=69e0646e&scoped=true&"
import script from "./DadosCadastroForm.vue?vue&type=script&lang=js&"
export * from "./DadosCadastroForm.vue?vue&type=script&lang=js&"
import style0 from "./DadosCadastroForm.vue?vue&type=style&index=0&id=69e0646e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69e0646e",
  null
  
)

export default component.exports